module.exports = __webpack_public_path__ + "static/img/mode3-3.fde184cf.png";